import type { participantes as pt } from '../pt-BR/participantes';
import type { Traducao } from '../Traducao';

export const participantes = {
  secao: 'Participants',
  elegiveis: 'In the campaign: {{n}}',
  excluidos: 'Excluded: {{n}}',
  acionadaPor: 'Triggered by',
  contagens: {
    incluidos: 'Included in this sync',
    alterados: 'Changed',
    reativados: 'Reactivated',
    excluidos: 'Excluded in this sync',
    ignorados: 'Ignored',
  },
  resultado: { sucesso: 'Success', falha: 'Failure' },
  confirmar:
    'This queries Axiis, adds the active professionals not yet in the campaign, updates the data of those already in it and marks those who left as excluded. No response is deleted. Continue?',
  confirmarAtivacao: 'The link starts accepting responses.',
  sincronizado: 'Synchronization complete: {{incluidos}} added, {{excluidos}} excluded.',
  falhou: 'The synchronization failed. See the reason in the summary.',
  status: {
    sincronizada_one: 'Synced on {{quando}} · {{count}} in the campaign',
    sincronizada_other: 'Synced on {{quando}} · {{count}} in the campaign',
    sincronizadaEm: 'Synced on {{quando}}',
    detalhes: 'Details',
  },
  aba: 'Participants',
  painel: {
    totais: {
      elegiveis: 'In the campaign',
      responderam: 'Responded',
      naoResponderam: 'Not responded',
      queremBrinde: 'Want the gift',
      exterior: 'Receiving abroad',
    },
    filtros: {
      busca: 'Name, e-mail or employee ID',
      buscaChip: 'Search',
      respondeu: 'Response',
      brinde: 'Gift',
      axiis: 'Axiis write',
      convite: 'Invitation',
      todos: 'All',
      sim: 'Yes',
      nao: 'No',
      falha: 'Failed',
      pendente: 'Pending',
      falhaOuPendente: 'Failed or pending',
      situacao: 'Status',
      rotulo: '{{filtro}}: {{valor}}',
    },
    situacao: { elegivel: 'In the campaign', excluido: 'Excluded' },
    colunas: {
      matricula: 'Employee ID',
      nome: 'Name',
      resposta: 'Response',
      brinde: 'Gift',
      camiseta: 'T-shirt',
      endereco: 'Address',
      atualizadaEm: 'Updated at',
      acoes: 'Actions',
      convite: 'Invitation',
    },
    respondeu: 'Responded',
    naoRespondeu: 'Not responded',
    entrega: {
      cadastro: 'Registry',
      outro: 'Other',
      exterior: 'Abroad',
      sem: 'No delivery address',
    },
    oficial: 'Official: {{situacao}}',
    gravacao: { sucesso: 'Written', pendente: 'Pending', falha: 'Failed', cancelada: 'Canceled' },
    vazio: 'No participants. Synchronize the campaign.',
    semResultado: 'No participants match these filters.',
  },
  linha: { abrir: 'Open {{nome}}' },
  detalhe: {
    titulo: 'Participant details',
    semResposta: 'This person has not responded yet.',
    semAlteracaoOficial: 'No change',
    matricula: 'Employee ID {{matricula}}',
    nome: 'Name',
    nomeSocial: 'Social name',
    nomePrefer: 'Preferred name',
    incluidoEm: 'Added on',
    primeiroAcesso: 'First visit',
    camiseta: 'T-shirt',
    versao: 'Version',
    primeiraResposta: 'First response',
    ultimaResposta: 'Last response',
    tentativas: '{{n}} attempts',
    itemCamiseta: 'T-shirt',
    itemEndereco: 'Official address',
    retentar: 'Try writing again',
    retentado_zero: '{{count}} written, {{falha}} failed.',
    retentado_one: '{{count}} written, {{falha}} failed.',
    retentado_other: '{{count}} written, {{falha}} failed.',
    retentadoNada: 'Nothing to write.',
    elegivel: 'In the campaign',
    excluido: 'Excluded',
    erro: 'Error loading the participant.',
    erroLista: 'Error loading the participants.',
    secoes: {
      identificacao: 'Identification',
      apresentado: 'Shown to the professional',
      respostas: 'Responses',
      entrega: 'Delivery address',
      oficial: 'Official address',
      confirmacoes: 'Confirmations',
      axiis: 'Axiis write',
      convite: 'Invitation',
    },
    fotografiaEm: 'Snapshot of',
    enderecoApresentado: 'Address',
    confirmacoesLinha: 'Correct address: {{correto}} · Someone to receive: {{recebedor}}',
    tentativa: '{{n}} attempt',
  },
  abas: { naCampanha: 'In the campaign', excluidos: 'Excluded' },
  lote: {
    enviarEmail: 'Send e-mail',
    barra: 'Bulk actions',
    selecionados_one: '{{count}} selected',
    selecionados_other: '{{count}} selected',
    selecionarPagina_one: '{{count}} on this page selected.',
    selecionarPagina_other: '{{count}} on this page selected.',
    selecionarPaginaRotulo: 'Select the rows on this page',
    selecionarLinha: 'Select {{nome}}',
    selecionarTodosFiltro: 'Select all {{total}} matching the filters',
    selecionarTodos: 'Select all ({{total}})',
    todosDoFiltroAtivo: '(everyone matching the filters)',
    foraDaLista_one: '{{count}} is not in this list',
    foraDaLista_other: '{{count}} are not in this list',
    verSelecionados: 'View selected',
    selecionadosTitulo: 'Selected people',
    tirar: 'Remove {{nome}} from the selection',
    tirarBotao: 'Remove',
    eMais_one: 'and {{count}} more person',
    eMais_other: 'and {{count}} more people',
    limpar: 'Clear selection',
    excluir: 'Remove from the campaign',
    devolver: 'Return to the campaign',
    excluirLinha: 'Remove {{nome}}',
    devolverLinha: 'Return {{nome}}',
    excluirTitulo_one: 'Remove {{count}} person from the campaign?',
    excluirTitulo_other: 'Remove {{count}} from the campaign?',
    devolverTitulo_one: 'Return {{count}} person to the campaign?',
    devolverTitulo_other: 'Return {{count}} to the campaign?',
    excluirCorpo_one:
      'This person leaves the list, receives no invitations and is left out of the export. A response already sent is kept. Synchronization does not bring them back; to bring them back, use "Return to the campaign".',
    excluirCorpo_other:
      'These people leave the list, receive no invitations and are left out of the export. Responses already sent are kept. Synchronization does not bring them back; to bring them back, use "Return to the campaign".',
    devolverCorpo_one:
      'This person returns to the campaign list. If inactive in the registry, they do not return.',
    devolverCorpo_other:
      'These people return to the campaign list. Those who are inactive in the registry do not return.',
    comResposta_one: '{{count}} already responded; the response is kept.',
    comResposta_other: '{{count}} already responded; the responses are kept.',
    resultado: '{{processados}}, {{ignorados}}.',
    soProcessados: '{{processados}}.',
    processados_zero: '{{count}} processed',
    processados_one: '{{count}} processed',
    processados_other: '{{count}} processed',
    ignoradosLote_one: '{{count}} ignored',
    ignoradosLote_other: '{{count}} ignored',
    verMotivos: 'See reasons',
    motivosTitulo: 'Ignored people',
    desatualizada: 'The list changed since you made your selection. Review it and try again.',
  },
  codigos: {
    INATIVO_NO_AXIIS: 'Inactive in the registry',
    JA_PARTICIPANTE: 'Already a participant',
    NAO_ENCONTRADO_NO_AXIIS: 'Not found in the registry',
    JA_EXCLUIDO: 'Was already removed',
    NAO_EXCLUIDO: 'Was already in the campaign',
    PARTICIPANTE_NAO_ENCONTRADO: 'Participant not found',
  },
  incluir: {
    botao: 'Add participant',
    titulo: 'Add participants to the campaign',
    busca: 'Search by name or employee ID',
    somenteAtivos: 'Only people who are active in the registry and not yet in the campaign appear.',
    semResultado: 'Nobody found for this search.',
    tentarDeNovo: 'Try again',
    adicionar: 'Add {{count}}',
  },
  idiomas: { PT: 'Portuguese', EN: 'English', ES: 'Spanish' },
  colunas: {
    idioma: 'Language',
    titulo: 'Columns',
    visiveis: 'Visible columns',
    redefinir: 'Reset',
    aplicar: 'Apply',
    nenhuma: 'Choose at least one column.',
    email: 'E-mail',
    acessos: 'Visits',
    ultimoAcesso: 'Last visit',
    origem: 'Source',
    por: 'Removed by',
  },
  origem: { sincronizacao: 'Synchronization', manual: 'Manual', axiis: 'Registry (Axiis)' },
  acessos: { nunca: 'Never', janela: 'We count a new visit every 30 minutes.' },
  filtros: {
    avancados: 'Filters',
    limparTudo: 'Clear all',
    fechar: 'Close',
    acessou: 'Visited',
    temEmail: 'Has e-mail',
    respondidaEm: 'Responded on',
    aplicados: 'Applied filters',
    remover: 'Remove filter {{filtro}}',
  },
  porPagina: 'Items per page',
  vazio: {
    excluidos: 'Nobody has been removed from this campaign.',
    titulo: 'No one in the campaign yet',
    descricao: "Bring the active professionals from Axiis. Then remove who won't receive it.",
  },
  inicioEFim: 'Start and end',
} as const satisfies Traducao<typeof pt>;
